export enum OrdersHttpPaths {
  Orders = '/shifts',
}
